(function (app, common) {
    const COOKIE_VALID_DAYS = 30;

    /**
     * Language Switcher
     *
     * @tutorial language-switcher
     * @param {HTMLElement} element Main container element of the language switcher
     * @class
     */
    app.Article = function (element) {
        let _self = this;

        const socialShare = element.querySelector('.js-social-share');
        if (socialShare) {
            new common.SharePage(socialShare);
        }
    };

    let widgets = document.querySelectorAll('[data-widget="article"]');
    Array.prototype.forEach.call(widgets, function (widget) {
        new app.Article(widget);
    });
})(PULSE.app, PULSE.app.common);
